/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgMarkdownBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.15551 16.1145V7.88589L8.08885 12.823L11.0222 7.88589V16.1145M16.8888 7.88589V16.1145M16.8888 16.1145L13.9555 13.0286M16.8888 16.1145L19.8222 13.0286M1 5.05714C1 3.92101 1.87553 3 2.95556 3H21.0444C22.1245 3 23 3.92101 23 5.05714V18.9429C23 20.079 22.1245 21 21.0444 21H2.95556C1.87553 21 1 20.079 1 18.9429V5.05714Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgMarkdown = wrapIcon(SvgMarkdownBase);
export default SvgMarkdown;
